/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import type {FlowInfo} from 'types/general';
import type {
	IConditionForm,
	ConditionObject,
	ITaiForm,
	IEcgiForm,
	INcgiForm,
	IServiceAreaIdForm,
	IPlmnIDForm,
	IActionForm,
	IPccRuleFormDynamic,
	IPccRuleFormStatic,
	IChargingParameterForm,
	IQosDataForm,
	IFlowInfoForm,
	IResetSMSForm,
} from 'interfaces';

import {defaultFormDataCondition} from 'pages/Policy/components/forms/utils/InitConditionLabels';

interface Transformation {
	$: {
		pre: string;
		ReMap: string[];
	};
}
interface PccRuleStatic {
	pccRuleId?: string;
}

interface PccRuleDynamic {
	precedence?: string;
	qosData?: any;
	chargingData?: any;
	flowInfo?: any[];
}

interface Config {
	$: {
		name: string;
		priority: string;
		scope: string;
		enabled: boolean;
	};
	conditions: object[];
	actions: object[];
	transformations?: Transformation[];
}

export const generateUUID = () => {
	if (typeof crypto !== 'undefined' && crypto.randomUUID) {
		return crypto.randomUUID();
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0;
		const v = c === 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

/**
 * "Round a number to a given number of decimal places, and optionally convert it to a percentage."
 *
 * The first argument is the number to round. The second argument is the number of decimal places to
 * round to. The third argument is a boolean that indicates whether the result should be converted to a
 * percentage
 * @param {number} num - The number to round.
 * @param [decimalPlaces=0] - The number of decimal places to round to.
 * @param [isPercentage=false] - If true, the result will be multiplied by 100.
 * @returns A function that takes in a number, decimalPlaces, and isPercentage.
 */
export const naiveRound = (
	num: number,
	decimalPlaces = 0,
	isPercentage = false,
) => {
	const p = Math.pow(10, decimalPlaces);
	const result = Math.round(num * p) / p;

	return isPercentage ? result * 100 : result;
};

/**
 * It takes a number of bytes and returns a human readable string
 * @param {string} x - The number of bytes to convert.
 * @returns An object with two properties, value and type.
 */
export const niceBytes = (x: string) => {
	const units = [
		'bytes',
		'KiB',
		'MiB',
		'GiB',
		'TiB',
		'PiB',
		'EiB',
		'ZiB',
		'YiB',
	];

	let l = 0,
		n = parseInt(x, 10) || 0;

	while (n >= 1024 && ++l) {
		n = n / 1024;
	}

	return {
		value: Number(n.toFixed(n < 10 && l > 0 ? 1 : 0)),
		type: units[l],
	};
};

/**
 * The function converts a given number of bytes to gigabytes and returns the result with two decimal
 * places.
 * @param {number} bytes - The parameter "bytes" is a number representing the size of a file or data in
 * bytes.
 * @returns The function `bytesToGB` returns a string representation of the number of gigabytes
 * equivalent to the input `bytes` argument, rounded to two decimal places.
 */
export const bytesToGB = (bytes: number) => {
	const gb = bytes / (1024 * 1024 * 1024);
	return gb.toFixed(2);
};

/**
 * It returns an object with three properties, each of which is an object with two properties
 */
export const defaultValuesMetrics = () => ({
	value: 0,
	used: {
		value: 0,
		type: '',
	},
	max: {
		value: 0,
		type: '',
	},
});

/**
 * Convert bytes to megabytes.
 * @param {number} bytes - The number of bytes to convert to megabytes.
 */
export const bytesToMegaBytes = (bytes: number) => bytes / (1024 * 1024);

/**
 * It takes two numbers, converts them to strings, then converts them to bytes, then converts them to
 * megabytes, then divides them, then returns an object with the used, max, and value properties
 * @param [used=0] - The amount of memory used.
 * @param [max=0] - The maximum value of the metric.
 */
export const calculateMetric = (used = 0, max = 0) => ({
	used: niceBytes(String(used)),
	max: niceBytes(String(max)),
	value: max > 0 ? bytesToMegaBytes(used) / bytesToMegaBytes(max) : 0,
});

/**
 * It takes a date object and returns a string with the date and time in a format that's easy to read
 * @param {Date} d - Date - the date to format
 * @returns A string with the date and time in the format of YYYY-MM-DD HH:MM:SS
 */
export const formatedTimestamp = (d: Date) => {
	const date = d.toISOString().split('T')[0];
	const time = d.toTimeString().split(' ')[0];
	return `${date} ${time}`;
};

/**
 * It takes an array of strings and an element of type string and returns an array of strings
 * @param {string[]} array - string[] - the array to fill
 * @param {string} el - string - the element to be added to the array
 * @returns The array is being returned as never.
 */
export const fillArrayStrings = (
	limit: number,
	array: string[],
	el: string,
) => {
	if (array.length <= limit) {
		array.push(el);
	} else {
		array.shift();
		array.push(el);
	}
	return array as never;
};

/**
 * It takes an array and an element, and if the array is less than a certain capacity, it pushes the
 * element to the array, otherwise it shifts the first element off the array and pushes the element to
 * the array
 * @param {number[]} array - number[] - the array to fill
 * @param {number} el - number - the element to be added to the array
 * @returns The array is being returned.
 */
export const fillArrayNumbers = (
	limit: number,
	array: number[],
	el: number,
) => {
	if (array?.length <= limit) {
		array.push(el);
	} else {
		array?.shift();
		array.push(el);
	}
	return array as never;
};

/**
 * The function `generateDatesArray` generates an array of formatted timestamps based on the current
 * date and time, with each timestamp being one second earlier than the previous one, up to a specified
 * limit.
 * @param {number} limit - The `limit` parameter is the number of dates you want to generate in the
 * array.
 * @returns an array of formatted timestamps.
 */
export const generateDatesArray = (limit: number) => {
	const datesArray = [];

	for (let i = 0; i < limit; i++) {
		const date = new Date();
		date.setSeconds(date.getSeconds() - i);
		datesArray.push(formatedTimestamp(date));
	}

	return datesArray;
};

/**
 * The function exports data to an XML file and allows the user to download it.
 * @param {unknown} data - The `data` parameter is the data that you want to export to XML format. It
 * can be of any type, but it will be casted to `never` type in this code snippet.
 * @param {string} name - The name parameter is a string that represents the desired name of the
 * downloaded XML file.
 */
export const exportDataToXml = (data: unknown, name: string) => {
	const blob = new Blob([data as never], {type: 'text/xml'});
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.download = `${name}.xml`;
	link.href = url;
	link.click();
};

/**
 * The function exports data to a CSV file and allows the user to download it.
 * @param {unknown} data - The `data` parameter is the data that you want to export to a CSV file. It
 * can be of any type, but it will be converted to a string before being exported.
 * @param {string} name - The name parameter is a string that represents the desired name of the
 * downloaded CSV file.
 */
export const exportDataToCsv = (data: unknown, name: string) => {
	const blob = new Blob([data as never], {type: 'text/csv'});
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.download = `${name}.csv`;
	link.href = url;
	link.click();
};

/**
 * The function `renderLoop` creates a loop that generates an object with nested arrays or numbers
 * based on the given parameters.
 * @param {number} total - The total number of iterations in the loop.
 * @param {number} LIMIT_ARRAY - The LIMIT_ARRAY parameter is the length of the array that will be
 * created using the Array.from method. It determines the number of elements in the array.
 * @param [isArray=true] - The `isArray` parameter is a boolean flag that determines whether the loop
 * should generate an array of arrays or just a single value. If `isArray` is `true`, the loop will
 * generate an array of arrays. If `isArray` is `false`, the loop will generate a single value.
 * @returns an object called "loop".
 */
export const renderLoop = (
	total: number,
	LIMIT_ARRAY: number,
	isArray = true,
) => {
	const GxValuesValuesArray = Array.from({length: LIMIT_ARRAY}, () => 0);
	let loop;
	for (let i = 0; i <= total; i++) {
		loop = {
			...(typeof loop === 'object' ? loop : {}),
			[i]: isArray ? [...GxValuesValuesArray] : 0,
		};
	}
	return loop;
};

/**
 * The function `getBrowserName` returns the name of the browser based on the user agent string.
 * @returns The function `getBrowserName` returns the name of the browser based on the user agent
 * string. It returns one of the following values: 'Edge', 'Opera', 'Chrome', 'Safari', 'Firefox', or
 * 'unknown'.
 */
export const getBrowserName = () => {
	if (
		navigator.userAgent.indexOf('Edge') > -1 &&
		navigator.appVersion.indexOf('Edge') > -1
	) {
		return 'Edge';
	} else if (
		navigator.userAgent.indexOf('Opera') != -1 ||
		navigator.userAgent.indexOf('OPR') != -1
	) {
		return 'Opera';
	} else if (navigator.userAgent.indexOf('Chrome') != -1) {
		return 'Chrome';
	} else if (navigator.userAgent.indexOf('Safari') != -1) {
		return 'Safari';
	} else if (navigator.userAgent.indexOf('Firefox') != -1) {
		return 'Firefox';
	} else {
		return 'unknown';
	}
};

/**
 * The function adds numeration to titles in an array of objects based on their type and occurrence.
 * @param {any[]} data - The `data` parameter is an array of objects. Each object represents an item
 * and has a `title` and `type` property. The function adds a numeration to the end of each `title`
 * property based on how many items have the same `title` and `type`.
 * @returns The function `addNumerationToTitles` returns an array of objects with updated `title`
 * properties that have a numeration added to them based on the occurrence of the same title and type
 * in the original array of objects passed as an argument. The function also logs the original array to
 * the console.
 */
export const addNumerationToTitles = (data: any[]) => {
	const titleCounts: any = {};
	return data?.map(item => {
		if (!titleCounts[item.title]) {
			titleCounts[item.title] = {};
		}
		if (!titleCounts[item.title][item.type]) {
			titleCounts[item.title][item.type] = 0;
		}
		titleCounts[item.title][item.type]++;
		const numeration =
			titleCounts[item.title][item.type] > 1
				? `_${titleCounts[item.title][item.type]}`
				: '';

		item.title = `${item.title}${numeration}`;

		return item;
	});
};

/**
 * The function `cleanObjectBeforeXML` removes empty or unnecessary properties from an object before
 * converting it to XML format.
 * @param {any} obj - The `obj` parameter is an object that needs to be cleaned before converting it to
 * XML format.
 * @returns the modified object after cleaning it.
 */
export const cleanObjectBeforeXML = (obj: any) => {
	if (obj) {
		Object.keys(obj).forEach(key => {
			if (key === '$' && 'pre' in obj[key]) {
				return;
			}

			if (obj[key] && typeof obj[key] === 'object') {
				// recursividad
				cleanObjectBeforeXML(obj[key]);

				// clean specific key
				if (
					Object.values(obj[key]).includes('') &&
					(key === 'servingNetwork' ||
						key === 'authSessAmbr' ||
						key === 'chargingData' ||
						key === 'chargingParameter' ||
						key === 'chargingInfo')
				) {
					if (key !== undefined) delete obj[key];
				}
				if (obj[key] && Object.keys(obj[key]).length === 0) {
					delete obj[key];
				}
			} else if (
				obj[key] === false ||
				obj[key] === undefined ||
				obj[key] === null ||
				obj[key] === '' ||
				obj[key].length === 0
			) {
				delete obj[key];
			}
		});
		return obj;
	}
};

/**
 * Cleans a condition form object by recursively removing inactive or empty condition fields.
 *
 * Only includes `ConditionObject` entries that are active and have non-empty values.
 * Nested objects (like `tai`, `ecgi`, etc.) are cleaned recursively.
 *
 * @param obj The original `IConditionForm` object.
 * @returns A new object of type `Partial<IConditionForm>` with cleaned condition fields.
 */
export const cleanConditionFormForXML = (
	obj: Record<string, any>,
): Record<string, any> => {
	const result: Record<string, any> = {};
	let hasActiveField = false;
	Object.entries(obj).forEach(([key, val]) => {
		if (key === 'id') return;
		// Si es un ConditionObject (tiene 'value' y 'active')
		if (val && typeof val === 'object' && 'value' in val && 'active' in val) {
			const isEmpty =
				val.value === '' ||
				val.value === null ||
				val.value === undefined ||
				(Array.isArray(val.value) && val.value.length === 0);

			if (val.active && !isEmpty) {
				result[key] = {
					value: val.value,
					active: true,
					...(val.notChecked !== undefined ? {notChecked: val.notChecked} : {}),
				} as any;
				hasActiveField = true;
			}
		} else if (val && typeof val === 'object') {
			// Limpieza recursiva para subobjetos (como tai, ecgi, etc.)
			const cleaned = cleanConditionFormForXML(val);
			if (Object.keys(cleaned).length > 0) {
				result[key] = cleaned as any;
				hasActiveField = true;
			}
		}
	});

	if (hasActiveField && obj.isGroup !== undefined) {
		result.isGroup = obj.isGroup;
		result.id = obj.id;
	}
	return result;
};

export const cleanActionFormForXML = (
	obj: Record<string, any>,
): Record<string, any> => {
	const result: Record<string, any> = {};
	Object.entries(obj).forEach(([key, val]) => {
		if (key === 'id') return;
		// Si es un ConditionObject (tiene 'value' y 'active')
		if (val && typeof val === 'object' && 'value' in val && 'active' in val) {
			const isEmpty =
				val.value === '' ||
				val.value === null ||
				val.value === undefined ||
				(Array.isArray(val.value) && val.value.length === 0);

			const specialKeys = [
				'flowDescription',
				'flowDirection',
				'tosTrafficClass',
			];
			const shouldInclude =
				(val.active && !isEmpty) || (specialKeys.includes(key) && !isEmpty);

			if (shouldInclude) {
				result[key] = {
					value: val.value,
					active: true,
					...(val.notChecked !== undefined ? {notChecked: val.notChecked} : {}),
				};
			}
		} else if (Array.isArray(val)) {
			const cleanedArray = val
				.map(item => cleanActionFormForXML(item))
				.filter(item => Object.keys(item).length > 0);

			if (cleanedArray.length > 0) {
				result[key] = cleanedArray;
			}
		} else if (val && typeof val === 'object') {
			const cleaned = cleanActionFormForXML(val);
			if (Object.keys(cleaned).length > 0) {
				result[key] = cleaned as any;
			}
		} else if (typeof val === 'boolean') {
			const specialKeys = [
				'hasRuleDynamic',
				'hasRuleStatic',
				'hasResetSMS',
				'hasFlowInfo',
			];
			const shouldInclude = specialKeys.includes(key);

			if (shouldInclude) {
				result[key] = val;
			}
		}
	});

	return result;
};

/* name includes in array data */
const NAME_INCLUDES = ['servingNetwork'];
export const parseFormDataActions = (data: any) => {
	const outputObject = JSON.parse(JSON.stringify(data), (key, value) => {
		switch (true) {
			case value === '':
				return false;
			case Array.isArray(value) && value.length === 0:
				return false;
			case typeof value === 'object' && Object.keys(value).length === 0:
				return false;
			case typeof value === 'object' && NAME_INCLUDES.includes(key):
				return Object.values(value).some((el: unknown) => el);
			case typeof value === 'string' && value !== '':
				return true;
			default:
				return value;
		}
	});
	return outputObject;
};

/**
 * The function `convertObjToArray` takes an array of objects and returns a new array where each
 * object's values are set to `false`.
 * @param {FlowInfo[]} arr - An array of objects of type FlowInfo.
 */
const convertObjToArray = (arr: FlowInfo[]) =>
	arr.map((obj: any) => {
		const newObj: any = {};
		for (const key in obj) {
			newObj[key] = false;
		}
		return newObj;
	});

/**
 * The function `convertObjectCheckbox` converts an object into a new object where all properties are
 * set to `false`, except for specific properties that are recursively converted or have a special
 * condition.
 * @param {any} obj - The `obj` parameter is an object that you want to convert into a new object with
 * checkboxes.
 * @returns The function `convertObjectCheckbox` returns a new object `newObj` with the same properties
 * as the input object `obj`, but with all values set to `false`.
 */
export const convertObjectCheckbox = (obj: any) => {
	const newObj: any = {};
	for (const prop in obj) {
		if (typeof obj[prop] === 'object' && obj[prop] !== null) {
			newObj[prop] =
				prop === 'flowInfo'
					? convertObjToArray(obj[prop])
					: convertObjectCheckbox(obj[prop]);

			if (prop === 'qosData' && obj[prop].hasOwnProperty('arp')) {
				newObj[prop] = {
					...obj[prop],
					arp: Object.values(convertObjectCheckbox(obj[prop].arp)).some(
						(el: unknown) => el,
					),
				};
			}
		} else {
			newObj[prop] = false;
		}
		if (prop === 'policyCtrlReqTrigger') {
			newObj[prop] = false;
		}
	}
	return newObj;
};

/**
 * The function `normalizeCheckbox` converts an object with checkbox values into a normalized object.
 * @param {any} obj - The `obj` parameter is an object that needs to be normalized.
 * @returns The function `normalizeCheckbox` returns a normalized version of the input object `obj`.
 */
export const normalizeCheckbox = (obj: any) => {
	const newObj = convertObjectCheckbox(obj);
	const newObjNormal: any = {};
	for (const prop in newObj) {
		if (
			typeof newObj[prop] === 'object' &&
			newObj[prop] !== null &&
			newObj[prop] === 'arp'
		) {
			newObjNormal[prop] =
				newObjNormal[prop].priorityLevel ||
				newObjNormal[prop].preemptCap ||
				newObjNormal[prop].preemptVuln;
		} else if (
			typeof newObj[prop] === 'object' &&
			newObj[prop] !== null &&
			prop === 'servingNetwork'
		) {
			newObjNormal[prop] = newObj[prop].mnc || newObj[prop].mcc;
		} else {
			newObjNormal[prop] = newObj[prop];
		}
	}
	return newObjNormal;
};

/**
 * The function removes the "transformations" property from the given "config" object if it exists and
 * is not empty.
 * @param {Config} config - The `config` parameter is an object that represents a configuration. It may
 * contain various properties, but the important one for this function is `transformations`. This
 * property is an array of objects, where each object represents a transformation.
 * @returns the updated `config` object after removing the `transformations` property if it is empty or
 * does not contain any valid transformations.
 */
export const removeTransformations = (config: Config): Config => {
	const {transformations} = config;
	if (transformations && transformations[0]) {
		// Hacer algo con transformations[0].ReMap si es necesario
	} else {
		delete config.transformations;
	}

	return config;
};

/**
 * The above code is a TypeScript function that converts a JSON object into a specific format and
 * filters out unnecessary properties.
 * @param {any} pccRule - The `pccRule` parameter is an array of properties pccRule found. Each object represents a PCC rule
 * and contains various properties such as `pccRuleId`, `precedence`, `qosData`, `chargingData`, and
 * `flowInfo`.
 * @returns The function `convertedJsonPccRule` returns an object with a property `pccRule` which
 * contains an array of objects. The function `filterJson` returns an object with properties other than
 * `pccRule` filtered out.
 */
const convertedJsonPccRule = (pccRule: any) => {
	const pccRuleJson: any = {};

	const propitiated = 'pccRule';
	for (const pccRuleIndex in pccRule) {
		pccRuleJson[propitiated] = pccRule[pccRuleIndex];
	}

	return pccRuleJson;
};

const convertedJsonResetSMS = (resetSMS: any) => {
	const resetSMSJson: any = {};

	const propitiated = 'resetSMS';
	for (const resetSMSIndex in resetSMS) {
		resetSMSJson[propitiated] = resetSMS[resetSMSIndex];
	}

	return resetSMSJson;
};

function filterJson(json: any): any {
	const filteredJson: any = {};

	for (const key in json) {
		if (key !== 'pccRule' && key !== 'resetSMS') {
			filteredJson[key] =
				Array.isArray(json[key]) && json[key].length > 0
					? json[key][0]
					: json[key];
		}
	}

	return filteredJson;
}

/**
 * Function to determine if a key is of PccRuleDynamic
 * @param {string} key - The key parameter is the key of the json property that is selected in the for iteration.
 * @return true if its dynamic pccRule
 */
function isDynamicKeyPCC(key: string): key is keyof PccRuleDynamic {
	return ['precedence', 'qosData', 'chargingData', 'flowInfo'].includes(key);
}

/**
 * Function to determine if a key is of PccRuleStatic
 * @param {string} key - The key parameter is the key of the json property that is selected in the for iteration.
 * @return true if its static pccRule
 */
function isStaticKeyPCC(key: string): key is keyof PccRuleStatic {
	return ['pccRuleId'].includes(key);
}

/**
 * The `convertViewJson` function converts a JSON object into a modified version by extracting specific
 * properties and restructuring them.
 * @param {any} json - The `json` parameter is an object that contains various properties and values.
 * @returns The function `convertViewJson` returns an object that is the result of merging the filtered
 * JSON object `json` with the converted PCC rule data.
 */
export const convertViewJson = (json: any): any => {
	const pccRuleArray: any[] = [];
	const resetSmSArray: string[] = [];

	if (json?.pccRule) {
		for (const rule of json?.pccRule) {
			const pccRuleDy: PccRuleDynamic = {};
			const pccRuleSta: PccRuleStatic = {};
			for (const key in rule) {
				if (isDynamicKeyPCC(key)) {
					pccRuleDy[key] = rule[key];
				} else if (isStaticKeyPCC(key)) {
					if (pccRuleDy === null || Object.keys(pccRuleDy).length === 0) {
						pccRuleSta[key] = rule[key];
						break;
					}
				}
			}

			if (pccRuleDy !== null && Object.keys(pccRuleDy).length > 0) {
				pccRuleArray.push(pccRuleDy);
			} else if (pccRuleSta !== null && Object.keys(pccRuleSta).length > 0) {
				pccRuleArray.push(pccRuleSta);
			}
		}
	}

	if (json?.resetSMS) {
		for (const namePolicy of json?.resetSMS) {
			resetSmSArray.push(namePolicy);
		}
	}

	let response = {
		...filterJson(json),
	};

	// integrate resetSMS
	if (json?.resetSMS) {
		response = {
			...response,
			...convertedJsonResetSMS([resetSmSArray]),
		};
	}

	// integrate pccRule
	if (json?.pccRule) {
		response = {
			...response,
			...convertedJsonPccRule([pccRuleArray]),
		};
	}

	return response;
};

/**
 * The function `hasRole` checks if a user has any of the specified roles.
 * @param {string[]} rolesListUser - An array of strings representing the roles of a user. Each string
 * in the array represents a role that the user has.
 * @param {string[]} role - An array of roles that you want to check if the user has.
 */
export const hasRole = (rolesListUser: string[], role: string[]) =>
	role.some(r => rolesListUser?.includes(r));

/**
 * The function checks if a given role exists in a list of roles.
 * @param {string[]} rolesListUser - An array of strings representing the roles of a user. Each string
 * in the array represents a role that the user has.
 * @param {string} role - The `role` parameter is a string that represents a specific role that we want
 * to check if it exists in the `rolesListUser` array.
 */
export const hasExactRole = (rolesListUser: string[], role: string) =>
	rolesListUser.some(r => role === r);

function transformValue(
	value: any,
	suppressNegate = false,
	keyInit = true,
): any {
	if (value === undefined || value === null || value === '') return undefined;

	if ('value' in value && 'active' in value) {
		const val = value.value;
		if (val === undefined || val === null || val === '') return undefined;

		const strVal = String(val);
		if (!suppressNegate && value.notChecked === true) {
			return {_: strVal, $: {negate: 'true'}};
		}
		return strVal;
	}

	if (typeof value === 'object') {
		const keys = Object.keys(value);
		const isNumericObject = keys.every(k => /^\d+$/.test(k));

		if (isNumericObject) {
			// Tratar como array
			const items = keys.map(k => value[k]);
			const transformedItems = items
				.map(child => transformValue(child, false, true))
				.filter(child => child !== undefined);
			return transformedItems.length > 0 ? transformedItems : undefined;
		}

		const nestedTransformed: any = {};
		let hasNegatedChild = false;
		let atLeastOneIncluded = false;

		for (const key in value) {
			const child = value[key];

			if (
				child &&
				typeof child === 'object' &&
				'notChecked' in child &&
				child.notChecked === true
			) {
				hasNegatedChild = true;
			}
		}

		for (const key in value) {
			const child = value[key];
			const transformedChild = transformValue(child, hasNegatedChild, false);

			if (transformedChild !== undefined) {
				atLeastOneIncluded = true;
				nestedTransformed[key] = transformedChild;
			}
		}

		if (!atLeastOneIncluded) return undefined;

		if (hasNegatedChild && keyInit) {
			nestedTransformed.$ = {negate: 'true'};
		}

		return nestedTransformed;
	}

	return undefined;
}

export function transformConditionsXML(conditions: IConditionForm[]) {
	const content: any = {};

	for (const condition of conditions) {
		// Si es un grupo, procesarlo por separado
		if (condition.isGroup) {
			const groupContent: any = {$: {relation: 'or'}};

			for (const key in condition) {
				if (key === 'id' || key === 'isGroup') continue;

				const value = (condition as any)[key];
				const transformedValue = transformValue(value);

				if (transformedValue !== undefined) {
					if (!groupContent[key]) groupContent[key] = [];

					if (Array.isArray(transformedValue)) {
						groupContent[key].push(...transformedValue);
					} else {
						groupContent[key].push(transformedValue);
					}
				}
			}

			if (!Array.isArray(content.group)) {
				content.group = [];
			}
			content.group.push(groupContent);
		} else {
			// Si no es un grupo, agregar las condiciones al nivel raíz
			for (const key in condition) {
				if (key === 'id' || key === 'isGroup') continue;

				const value = (condition as any)[key];
				const transformedValue = transformValue(value);

				if (transformedValue !== undefined) {
					if (!content[key]) content[key] = [];

					if (Array.isArray(transformedValue)) {
						content[key].push(...transformedValue);
					} else {
						content[key].push(transformedValue);
					}
				}
			}
		}
	}

	return content;
}

const defaultEmptyCondition = defaultFormDataCondition({});

function isArrayField(field: keyof IConditionForm): boolean {
	const value = defaultEmptyCondition[field];
	return Array.isArray(value);
}

function parseConditionArray(
	values: any[],
): Record<number, ConditionObject<string>> | undefined {
	if (!Array.isArray(values) || values.length === 0) return undefined;

	const result: Record<number, ConditionObject<string>> = {};

	values.forEach((val, index) => {
		if (typeof val === 'string') {
			result[index] = {
				value: val,
				active: true,
				notChecked: false,
			};
		} else if (typeof val === 'object' && val._ !== undefined) {
			result[index] = {
				value: val._,
				active: true,
				notChecked: val.$?.negate === 'true',
			};
		}
	});

	return Object.keys(result).length > 0 ? result : undefined;
}

function propagateNegateToChildren<T extends Record<string, any>>(
	obj: T,
	negate: boolean,
): T {
	if (!negate) return obj;

	const applyNotRecursively = (value: any): any => {
		if (
			value &&
			typeof value === 'object' &&
			'value' in value &&
			'active' in value
		) {
			return {
				...value,
				notChecked: true,
			};
		} else if (value && typeof value === 'object') {
			const newObj: Record<string, any> = {};
			for (const [key, val] of Object.entries(value)) {
				newObj[key] = applyNotRecursively(val);
			}
			return newObj;
		}
		return value;
	};

	return applyNotRecursively(obj);
}

function parseConditionValue(value: any): ConditionObject<any> | undefined {
	if (value == null) return undefined;
	if (Array.isArray(value)) {
		const item = value[0];

		if (typeof item === 'string') {
			return {
				value: item,
				notChecked: false,
				active: true,
			};
		}

		if (typeof item === 'object' && item._ !== undefined) {
			return {
				value: item._,
				notChecked: item.$?.negate === 'true',
				active: true,
			};
		}
	}

	return undefined;
}

function parsePlmnId(value: any): IPlmnIDForm | undefined {
	let plmn;
	if (Array.isArray(value) || value.length === 0) {
		plmn = value[0];
	} else {
		plmn = value;
	}
	const negate = plmn?.$?.negate === 'true';

	const mcc = parseConditionValue(plmn.mcc);
	const mnc = parseConditionValue(plmn.mnc);

	let result: IPlmnIDForm = {};
	if (mcc) result.mcc = mcc;
	if (mnc) result.mnc = mnc;

	if (Object.keys(result).length > 0) {
		result = propagateNegateToChildren(result, negate);
		return result;
	}

	return undefined;
}

function parsePlmnIdList(value: any): IPlmnIDForm[] | undefined {
	if (!value) return undefined;

	const valueArray = Array.isArray(value) ? value : [value];

	const parsedList = valueArray
		.map(item => parsePlmnId(item))
		.filter((v): v is IPlmnIDForm => v !== undefined);

	return parsedList.length > 0 ? parsedList : undefined;
}

function parseTaiCondition(value: any[]): ITaiForm[] | undefined {
	if (!Array.isArray(value)) return undefined;

	const result: ITaiForm[] = [];

	for (const item of value) {
		const negate = item?.$?.negate === 'true';
		const tai: Partial<ITaiForm> = {};

		if (item.plmnId) {
			const plmn = parsePlmnId(item.plmnId);
			if (plmn) tai.plmnId = plmn;
		}

		if (item.tac) {
			const tac = parseConditionValue(item.tac);
			if (tac) tai.tac = tac;
		}

		if (Object.keys(tai).length > 0) {
			result.push(propagateNegateToChildren(tai, negate) as ITaiForm);
		}
	}

	return result.length > 0 ? result : undefined;
}

function parseEcgiCondition(value: any[]): IEcgiForm[] | undefined {
	if (!Array.isArray(value)) return undefined;

	const result: IEcgiForm[] = [];

	for (const item of value) {
		const negate = item?.$?.negate === 'true';
		const ecgi: Partial<IEcgiForm> = {};

		if (item.plmnId) {
			const plmn = parsePlmnId(item.plmnId);
			if (plmn) ecgi.plmnId = plmn;
		}

		if (item.eutraCellId) {
			const eutraCellId = parseConditionValue(item.eutraCellId);
			if (eutraCellId) ecgi.eutraCellId = eutraCellId;
		}

		if (Object.keys(ecgi).length > 0) {
			result.push(propagateNegateToChildren(ecgi, negate) as IEcgiForm);
		}
	}

	return result.length > 0 ? result : undefined;
}

function parseNcgiCondition(value: any[]): INcgiForm[] | undefined {
	if (!Array.isArray(value)) return undefined;

	const result: INcgiForm[] = [];

	for (const item of value) {
		const negate = item?.$?.negate === 'true';
		const ncgi: Partial<INcgiForm> = {};

		if (item.plmnId) {
			const plmn = parsePlmnId(item.plmnId);
			if (plmn) ncgi.plmnId = plmn;
		}

		if (item.nrCellId) {
			const nrCellId = parseConditionValue(item.nrCellId);
			if (nrCellId) ncgi.nrCellId = nrCellId;
		}

		if (item.nid) {
			const nid = parseConditionValue(item.nid);
			if (nid) ncgi.nid = nid;
		}

		if (Object.keys(ncgi).length > 0) {
			result.push(propagateNegateToChildren(ncgi, negate) as INcgiForm);
		}
	}

	return result.length > 0 ? result : undefined;
}

function parseSaiCondition(value: any[]): IServiceAreaIdForm[] | undefined {
	if (!Array.isArray(value)) return undefined;

	const result: IServiceAreaIdForm[] = [];

	for (const item of value) {
		const negate = item?.$?.negate === 'true';
		const sai: Partial<IServiceAreaIdForm> = {};

		if (item.plmnId) {
			const plmn = parsePlmnId(item.plmnId);
			if (plmn) sai.plmnId = plmn;
		}

		if (item.lac) {
			const lac = parseConditionValue(item.lac);
			if (lac) sai.lac = lac;
		}

		if (item.sac) {
			const sac = parseConditionValue(item.sac);
			if (sac) sai.sac = sac;
		}

		if (Object.keys(sai).length > 0) {
			result.push(propagateNegateToChildren(sai, negate) as IServiceAreaIdForm);
		}
	}

	return result.length > 0 ? result : undefined;
}

function isComplexField(field: keyof IConditionForm): boolean {
	return ['tai', 'ecgi', 'ncgi', 'servingNetwork', 'sai'].includes(field);
}

function parseComplexCondition(value: any, field: keyof IConditionForm): any {
	if (!Array.isArray(value) || value.length === 0) return undefined;

	switch (field) {
		case 'tai':
			return parseTaiCondition(value);
		case 'ecgi':
			return parseEcgiCondition(value);
		case 'ncgi':
			return parseNcgiCondition(value);
		case 'servingNetwork':
			return parsePlmnIdList(value);
		case 'sai':
			return parseSaiCondition(value);
		default:
			return undefined;
	}
}

function readCondition(
	field: keyof IConditionForm,
	value: any,
): ConditionObject<any> | Record<number, ConditionObject<any>> | undefined {
	if (isComplexField(field)) {
		return parseComplexCondition(value, field);
	}

	if (isArrayField(field)) {
		return parseConditionArray(value);
	} else {
		return parseConditionValue(value);
	}
}

function findConditionsSimple(obj: any): Partial<IConditionForm> | undefined {
	const individualConditions: Partial<IConditionForm> = {};
	for (const [key, value] of Object.entries(obj[0])) {
		if (key === 'group') continue;
		const transformedValue = readCondition(key as keyof IConditionForm, value);

		if (transformedValue == null) {
			return undefined;
		}

		(individualConditions as Record<string, unknown>)[key] = transformedValue;
	}

	if (Object.keys(individualConditions).length > 0) {
		individualConditions.isGroup = false;
	}

	return Object.keys(individualConditions).length > 0
		? individualConditions
		: undefined;
}

function findConditionsGroup(obj: any): IConditionForm[] | undefined {
	const groupConditions: IConditionForm[] = [];

	if (!Array.isArray(obj) || obj.length === 0) return undefined;

	const groupItem = obj[0];
	if (!groupItem.group || !Array.isArray(groupItem.group)) return undefined;

	for (const item of groupItem.group) {
		const partialIConditionForm: Partial<IConditionForm> = {isGroup: true};
		for (const [keyII, valueII] of Object.entries(item)) {
			if (Array.isArray(valueII)) {
				const arrayConditionSimple = readCondition(
					keyII as keyof IConditionForm,
					valueII,
				);
				if (arrayConditionSimple !== undefined) {
					(partialIConditionForm as any)[keyII] = arrayConditionSimple;
				}
			}
		}
		groupConditions.push(partialIConditionForm as IConditionForm);
	}

	return groupConditions.length > 0 ? groupConditions : undefined;
}

export function parseConditionsFromXML(obj: any): IConditionForm[] {
	const result: IConditionForm[] = [];
	if (!obj) return result;
	const individualConditions = findConditionsSimple(obj);
	const groupConditions = findConditionsGroup(obj);
	if (individualConditions) {
		result.push(individualConditions as IConditionForm);
	}

	if (groupConditions && groupConditions.length > 0) {
		result.push(...groupConditions);
	}
	return result;
}

function transformActionValue(value: any): any {
	if (value === undefined || value === null || value === '') return undefined;

	if (typeof value === 'object' && 'value' in value) {
		const val = value.value;
		if (val === undefined || val === null || val === '') return undefined;
		return String(val);
	}

	if (Array.isArray(value)) {
		const transformedItems = value
			.map(child => transformActionValue(child))
			.filter(v => v !== undefined);
		return transformedItems.length > 0 ? transformedItems : undefined;
	}

	if (typeof value === 'object') {
		const nested: any = {};
		let atLeastOne = false;

		for (const key in value) {
			if (key === 'pccRuleId' && value[key]?.pccRuleId) {
				const pccRuleIdVal = value[key].pccRuleId?.value;
				const crbnVal = value[key].crbn?.value;
				if (pccRuleIdVal !== undefined) {
					nested[key] = {_: String(pccRuleIdVal)};
					if (crbnVal !== undefined) {
						nested[key].$ = {crbn: String(crbnVal)};
					}
					atLeastOne = true;
				}
				continue;
			}

			const transformedChild = transformActionValue(value[key]);
			if (transformedChild !== undefined) {
				nested[key] = transformedChild;
				atLeastOne = true;
			}
		}
		return atLeastOne ? nested : undefined;
	}
	return undefined;
}

export function transformActionsXML(action: IActionForm) {
	const content: any = {};

	for (const key in action) {
		const value = (action as any)[key];

		if (key === 'pccRuleDynamic' || key === 'pccRuleStatic') {
			if (Array.isArray(value)) {
				value.forEach((item: any) => {
					const transformed = transformActionValue(item);
					if (transformed) {
						if (!content.pccRule) content.pccRule = [];
						content.pccRule.push(transformed);
					}
				});
			}
			continue;
		}

		if (key === 'resetSMS') {
			if (Array.isArray(value)) {
				value.forEach((item: any) => {
					const resetSMSField = item.resetSMS;
					const transformed = transformActionValue(resetSMSField);
					if (transformed) {
						if (!content.resetSMS) content.resetSMS = [];
						content.resetSMS.push(transformed);
					}
				});
			}
			continue;
		}

		const transformedValue = transformActionValue(value);
		if (transformedValue !== undefined) {
			if (!content[key]) content[key] = [];
			content[key].push(transformedValue);
		}
	}

	return content;
}

export function parseActionsFromXML(json: any[]): IActionForm {
	const convertValue = (val: any): ConditionObject<any> => {
		const value = Array.isArray(val) ? val[0] : val;
		const isEmpty = value === undefined || value === null || value === '';
		return {
			value,
			active: !isEmpty,
			notChecked: false,
		};
	};

	const anyFieldActive = (obj: any): boolean =>
		Object.values(obj).some(
			v =>
				typeof v === 'object' &&
				v !== null &&
				'active' in v &&
				v.active === true,
		);

	const result: Partial<IActionForm> = {};
	if (!Array.isArray(json) || json.length === 0) return result as IActionForm;

	const first = json[0];

	if (first.authDefQos) {
		const fiveQi = convertValue(first.authDefQos._5qi);
		const arp = first.authDefQos.arp?.[0] || {};
		const priorityLevel = convertValue(arp.priorityLevel);
		const preemptCap = convertValue(arp.preemptCap);
		const preemptVuln = convertValue(arp.preemptVuln);

		if (
			fiveQi.active ||
			priorityLevel.active ||
			preemptCap.active ||
			preemptVuln.active
		) {
			result.authDefQos = {
				_5qi: fiveQi,
				arp: {
					priorityLevel,
					preemptCap,
					preemptVuln,
				},
			};
		}
	}

	if (first.authSessAmbr) {
		const uplink = convertValue(first.authSessAmbr.uplink);
		const downlink = convertValue(first.authSessAmbr.downlink);
		if (uplink.active || downlink.active) {
			result.authSessAmbr = {uplink, downlink};
		}
	}

	if (first.precedence) {
		const precedence = convertValue(first.precedence);
		if (precedence.active) result.precedence = precedence;
	}

	if (first.sms) {
		const sms = convertValue(first.sms);
		if (sms.active) result.sms = sms;
	}
	if (first.terminate) {
		const terminate = convertValue(first.terminate);
		if (terminate.active) result.terminate = terminate;
	}
	if (first.monitoringKey) {
		const monitoringKey = convertValue(first.monitoringKey);
		if (monitoringKey.active) result.monitoringKey = monitoringKey;
	}

	if (first.resetSMS?.length) {
		const mapped = first.resetSMS
			.map(
				(val: any): IResetSMSForm => ({
					id: `resetSMS-${generateUUID()}`,
					resetSMS: convertValue(val),
				}),
			)
			.filter((item: IResetSMSForm) => item.resetSMS.active);

		if (mapped.length > 0) {
			result.resetSMS = mapped;
			result.hasResetSMS = true;
		}
	}

	if (first.pccRule) {
		const dynamic: IPccRuleFormDynamic[] = [];
		const statics: IPccRuleFormStatic[] = [];

		first.pccRule.forEach((item: any) => {
			if (item.pccRuleId) {
				const pcc = item.pccRuleId[0];
				const pccRuleId = convertValue(pcc._);
				const crbn = convertValue(pcc.$?.crbn);
				if (pccRuleId.active) {
					statics.push({
						id: `pccRuleStatic-${generateUUID()}`,
						pccRuleId: {pccRuleId, crbn},
					});
				}
			} else {
				const qos = item.qosData?.[0] || {};
				const arp = qos.arp?.[0] || {};
				const charging = item.chargingData?.[0] || {};

				const flowInfoList = Array.isArray(item.flowInfo)
					? item.flowInfo
							.map((f: any) => {
								const flowDescription = convertValue(f.flowDescription);
								const flowDirection = convertValue(f.flowDirection);
								const tosTrafficClass = convertValue(f.tosTrafficClass);
								if (
									!flowDescription.active &&
									!flowDirection.active &&
									!tosTrafficClass.active
								) {
									return null;
								}
								return {
									id: `flowInfo-${generateUUID()}`,
									flowDescription,
									flowDirection,
									tosTrafficClass,
								};
							})
							.filter(Boolean)
					: [];

				const hasFlowInfo = flowInfoList.length > 0;

				const pccRuleBase: Partial<IPccRuleFormDynamic> = {
					id: `pccRule-${generateUUID()}`,
					precedence: convertValue(item.precedence),
					qosData: {
						_5qi: convertValue(qos._5qi),
						maxbrUl: convertValue(qos.maxbrUl),
						maxbrDl: convertValue(qos.maxbrDl),
						gbrUl: convertValue(qos.gbrUl),
						gbrDl: convertValue(qos.gbrDl),
						arp: {
							priorityLevel: convertValue(arp.priorityLevel),
							preemptCap: convertValue(arp.preemptCap),
							preemptVuln: convertValue(arp.preemptVuln),
						},
					},
					chargingData: {
						chgId: convertValue(charging.chgId),
						offline: convertValue(charging.offline),
						online: convertValue(charging.online),
						ratingGroup: convertValue(charging.ratingGroup),
						serviceId: convertValue(charging.serviceId),
						reportingLevel: convertValue(charging.reportingLevel),
						afChargingIdentifier: convertValue(charging.afChargingIdentifier),
					},
					afSigProtocol: convertValue(item.afSigProtocol),
				};

				if (hasFlowInfo) {
					pccRuleBase.hasFlowInfo = true;
					pccRuleBase.flowInfo = flowInfoList as IFlowInfoForm[];
				}

				if (
					anyFieldActive(pccRuleBase.qosData) ||
					anyFieldActive(pccRuleBase.qosData?.arp) ||
					anyFieldActive(pccRuleBase.chargingData) ||
					pccRuleBase.precedence?.active ||
					pccRuleBase.afSigProtocol?.active ||
					hasFlowInfo
				) {
					dynamic.push(pccRuleBase as IPccRuleFormDynamic);
				}
			}
		});

		if (dynamic.length > 0) {
			result.pccRuleDynamic = dynamic;
			result.hasRuleDynamic = true;
		}

		if (statics.length > 0) {
			result.pccRuleStatic = statics;
			result.hasRuleStatic = true;
		}
	}

	// qosData raíz
	if (first.qosData) {
		const qosRoot = first.qosData || {};
		const qosArp = qosRoot.arp?.[0] || {};
		const qosDataRoot: IQosDataForm = {
			_5qi: convertValue(qosRoot._5qi),
			maxbrUl: convertValue(qosRoot.maxbrUl),
			maxbrDl: convertValue(qosRoot.maxbrDl),
			gbrUl: convertValue(qosRoot.gbrUl),
			gbrDl: convertValue(qosRoot.gbrDl),
			arp: {
				priorityLevel: convertValue(qosArp.priorityLevel),
				preemptCap: convertValue(qosArp.preemptCap),
				preemptVuln: convertValue(qosArp.preemptVuln),
			},
		};
		if (anyFieldActive(qosDataRoot) || anyFieldActive(qosDataRoot.arp)) {
			result.qosData = qosDataRoot;
		}
	}

	const chParam = first.chargingParameter || {};
	const chInfo = chParam.chargingInfo?.[0] || {};

	const chargingParameter: IChargingParameterForm = {
		online: convertValue(chParam.online),
		offline: convertValue(chParam.offline),
		chargingInfo: {
			primaryChfAddress: convertValue(chInfo.primaryChfAddress),
			secondaryChfAddress: convertValue(chInfo.secondaryChfAddress),
		},
	};

	if (
		chargingParameter.online.active ||
		chargingParameter.offline.active ||
		anyFieldActive(chargingParameter.chargingInfo)
	) {
		result.chargingParameter = chargingParameter;
	}

	return result as IActionForm;
}
